import React, { useState, useEffect} from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import { AssessmentTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import "./Entity.scss";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

const Entity = () => {
	const x = 0;
	const [contentNav, setContentNav] = useState('');
	useEffect(() => { //
		getContentNavData();
	}, []);

	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const getContentNavData = async() => {
		await axios.get(process.env.REACT_APP_API_URL+'get_content_nav_data', {
            params:{
                name: 'entity',
				content_nav: get_cookies('content.nav.access')
            }
			}).then(function (res) {
				setContentNav(res.data.data);
		  	}).catch(function (error) {	
				// console.log(error);
	  		});
	}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AccountBalanceIcon />
				</div>
				<h2 className="header-title">Entity</h2>
			</div>
			<div className="page-container">
					<Grid container spacing={2}>
						{contentNav ? contentNav.map((item)=>{
								return(
									<Grid item  xs={12} sm={6} className="app-card-container" key={item.id} 									style={{
										"--cardBorderColor": item.nav_color
									}}>
										<NavLink to={item.cn_url} key={item.id}>
											<div className="app-card">
												{item.cn_name}
											</div>
										</NavLink> 
									</Grid>	
								)
							})
							: (<Preloader />)}
					</Grid>
			</div>
		</div>
	);
};

export default Entity;
